// Local translations
export const T = {
  en_GB: {
    youtubeUrl: "YouTube URL",
    placeholder: "https://www.youtube.com/watch?v=...",
    helpText: "Enter a YouTube video URL (youtube.com or youtu.be)",
  },
  nb_NO: {
    youtubeUrl: "YouTube-URL",
    placeholder: "https://www.youtube.com/watch?v=...",
    helpText: "Skriv inn en YouTube-video-URL (youtube.com eller youtu.be)",
  },
} as const;
